<template>
  <div id="home">
    <div id="logo-container" class="card">
      <img id="logo" :src="require('@/assets/logo.jpg')" />
    </div>
    <div class="card" style="margin-top: 1rem">
      <h1 class="name">MECHAHOLICS 2020</h1>
      <hr />
      <div class="tagline">
        A National Level Technical Symposium
        <br />By Department of Mechanical Engineering, Meenakshi College of Engineering
        <br />on
        <b style="line-height: 1.4rem">
          <em>March 6, 2020</em>
        </b>
      </div>
    </div>
    <div class="card">
      <div class="title">Starts in</div>
      <hr />
      <countdown-timer :end-time="new Date(2020, 2, 6, 9, 0, 0, 0)" style="margin-top: 1rem" />
    </div>
    <a href="https://goo.gl/maps/KC49HwqxuuVYNckn8" target="_blank">
      <div class="card">
        <div class="title">Venue</div>
        <hr />
        <div class="tagline">
          At Meenakshi College of Engineering
          <br />#12, Vembuliamman Koil Street, West K.K. Nagar, Chennai-78
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.9045908150415!2d80.18651991482278!3d13.041744690809935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266cd13687e19%3A0xcde1489bf2db3882!2sMeenakshi+College+Of+Engineering!5e0!3m2!1sen!2sin!4v1565530456057!5m2!1sen!2sin"
          frameborder="0"
          style="border:0"
          allowfullscreen
          class="location-map"
        ></iframe>
      </div>
    </a>
    <div class="card">
      <div class="title">Contact us</div>
      <hr />
      <div class="tagline" style="font-size: 1.4rem">
        <a href="mailto:mechaholics2020@gmail.com">MECHAHOLICS2020@GMAIL.COM</a>
      </div>
      <div class="tagline">
        <br/>
        <span style="font-size: 1.1rem;">Overall Event Coordinators</span>
        <table class="contact-details">
          <tr>
            <td style="width:50%; text-align:start">Rakesh Menon</td>
            <td>:</td>
            <td style="width:50%; text-align: end">
              <a href="tel:+917904013122">&nbsp;&nbsp;+919791070751</a>
            </td>
          </tr>
          <tr>
            <td style="width:50%; text-align:start">Aravind</td>
            <td>:</td>
            <td style="width:50%; text-align:end">
              <a href="tel:+916380667500">&nbsp;&nbsp;+918667702485</a>
            </td>
          </tr>
        </table>
        <br/>
        <span style="font-size: 1.1rem;">Staff Incharge</span>
        <table class="contact-details">
          <tr>
            <td style="width:50%; text-align:start">Arun B</td>
            <td>:</td>
            <td style="width:50%; text-align: end">
              <a href="tel:+917904013122">&nbsp;&nbsp;+919789930082</a>
            </td>
          </tr>
          <tr>
            <td style="width:50%; text-align:start">Senthil Kumar R</td>
            <td>:</td>
            <td style="width:50%; text-align:end">
              <a href="tel:+916380667500">&nbsp;&nbsp;+919677328211</a>
            </td>
          </tr>
        </table>
        <br/>
        <span style="font-size: 1.1rem;">Technical Event Coordinators</span>
        <table class="contact-details">
          <tr>
            <td style="width:50%; text-align:start">Lakshman</td>
            <td>:</td>
            <td style="width:50%; text-align: end">
              <a href="tel:+917904013122">&nbsp;&nbsp;+919677273521</a>
            </td>
          </tr>
          <tr>
            <td style="width:50%; text-align:start">Muthu Vignesh</td>
            <td>:</td>
            <td style="width:50%; text-align:end">
              <a href="tel:+916380667500">&nbsp;&nbsp;+917299572653</a>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="card">
      <div class="title">Follow us on</div>
      <hr />
      <div class="tagline">
        <a target="_blank" href="https://instagram.com/mechaholics_2020/">
          <img class="follow-icon" :src="require('@/assets/instagram.svg')" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CountdownTimer from "@/components/CountdownTimer.vue";

export default {
  name: "HomePage",
  components: {
    CountdownTimer
  }
};
</script>

<style>
#home {
  min-height: 90vh;
  padding: 1vh 0 9vh 0;
  color: white;
  text-align: center;
}

.name {
  font-size: 2.5rem;
  line-height: 1rem;
  color: var(--font-dark);
}

.tagline {
  margin: 0.5rem 1rem 0 1rem;
  font-size: 1.05rem;
  line-height: 1.25rem;
  text-align: center;
}

.contact-details {
  width: 100%;
  margin: 5px auto 0 auto;
}

#logo-container {
  display: block;
  margin: auto;
  height: 12rem;
  width: 12rem;
  padding: 0.2rem;
  background: white;
  border-radius: 50%;
}

#logo {
  height: 12rem;
  width: 12rem;
  border-radius: 50%;
}

.location-map {
  width: 90%;
  margin: 2% 5% 0 5%;
  height: 25rem;
}

.follow-icon {
  width: 3rem;
  height: 3rem;
  margin: 0 1.5rem;
}

div.card {
  margin-top: 1.8rem;
}

@media only screen and (max-width: 900px) {
  div.card {
    width: 80%;
  }

  .contact-details {
    width: 80%;
  }
}

@media only screen and (min-width: 900px) {
  div.card {
    width: 60%;
  }

  .contact-details {
    width: 60%;
  }
}

@media only screen and (max-width: 700px) {
  div.card {
    width: 95%;
    margin-top: 1rem;
  }

  .name {
    font-size: 2.25rem;
  }

  .contact-details {
    width: 80%;
  }
}
</style>